import React from 'react';
import DashboardNav from './DashboardNav';
import AgenturManagement from './AgenturManagement';
import { useNavigate, useParams } from 'react-router-dom';

function AgenturManagementWrapper({ user }) {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleLogout = () => navigate('/');
  const handleSectionChange = (section) => {
    if (section === 'dashboard') navigate('/dashboard');
    // Weitere Sektionen nach Bedarf ergänzen
  };

  return (
    <>
      <DashboardNav
        activeSection="agenturen"
        onSectionChange={handleSectionChange}
        onLogout={handleLogout}
        user={user}
      />
      <div className="page-container">
        <AgenturManagement agenturId={id} user={user} />
      </div>
    </>
  );
}

export default AgenturManagementWrapper;
